import Moment from "moment/moment"
import { MedicalInfo } from "../../types/MedicalInfo"
import {
  AFAB_ONLY_ANSWER_KEYS,
  AMAB_ONLY_ANSWER_KEYS,
  PREGNANCY_ANSWER_KEYS,
  POSTPARTUM_ANSWER_KEYS
} from "./MedicalInfoQuestions"

export function getMedicalQuestionsWorkflowClause(medicalInfo: MedicalInfo): string {
  const answeredQuestionKeys = Object.entries(medicalInfo)
    .filter(([, value]) => value != null)
    .map(([key]) => key)

  if (answeredQuestionKeys.some((key) => AFAB_ONLY_ANSWER_KEYS.has(key))) return "AFAB medical questions "
  if (answeredQuestionKeys.some((key) => AMAB_ONLY_ANSWER_KEYS.has(key))) return "AMAB medical questions "
  if (answeredQuestionKeys.some((key) => PREGNANCY_ANSWER_KEYS.has(key))) return "Pregnancy medical questions "
  if (answeredQuestionKeys.some((key) => POSTPARTUM_ANSWER_KEYS.has(key))) return "Postpartum medical questions "

  return "Medical questions "
}

export function getMedicalInfoSubHeaderText(medicalInfo: MedicalInfo): string {
  const workflowClause = getMedicalQuestionsWorkflowClause(medicalInfo)
  const dateClause = medicalInfo.medicalInfoCompletedDate
    ? "completed " + Moment(medicalInfo.medicalInfoCompletedDate).format("l")
    : ""
  const sourceClause = medicalInfo.isFromCarrotPlanMenuItem ? " via Carrot Plan" : ""
  return workflowClause + dateClause + sourceClause
}
